import API from './axios.js';


// export const getHighCourtCustomerCases = () => API.get('case/high-court/by-client');
// export const getDistrictCourtCustomerCases = () => API.get('case/district-court/by-client');
// export const getOtherCourtCustomerCases = () => API.get('case/district-court/by-client');


export const getHighCourtCustomerCases = (queryParams = '') => API.get(`case/high-court/by-client${queryParams}`)
export const getDistrictCourtCustomerCases = (queryParams = '') => API.get(`case/district-court/by-client${queryParams}`)
export const getOtherCourtCustomerCases = (queryParams = '') => API.get(`case/other-court/by-client${queryParams}`)
